<template>
  <div
    class="v-input flex flex-wrap flex-direction-column"
    :class="className + ( label ? ' pt-4' : '')">
    <v-textarea
      ref="bordered_textarea"
      v-model="model_text"
      :auto-grow="!not_grow"
      :autofocus="autofocus"
      class="custom-textarea"
      :class="[area_class_name || '' , rounded ? ' rounded ' : '' ]"
      color="var(--black-color)"
      :counter="counter"
      :counter-value="counter_value"
      data-qa="textarea"
      :disabled="disabled"
      :error.sync="error_sync"
      :error-message="errorMessages"
      :error-messages="error_sync ? error_text : ''"
      :hide-details="hide_details"
      :hint="hint"
      :no-resize="not_grow"
      :outlined="rounded"
      :persistent-placeholder="!!placeholder"
      :placeholder="placeholder"
      :prefix="prefix"
      :prepend-inner-icon="prepend_inner_icon"
      :readonly="readonly"
      row-height="18"
      :rows="rows"
      :rules="all_rules"
      :validate-on-blur="validateOnBlur"
      @blur="blur"
      @click="$emit('click')"
      @focus="focus"
      @keydown.enter="$emit('keydown_enter')"
      @keydown.esc="$emit('keydown_esc')"
      @paste="evt => $emit('paste', evt.clipboardData.getData('text/plain'))">
      <template #prepend-inner>
        <slot name="area-prepend-inner"/>
      </template>
      <template
        v-if="clearable"
        #append>
        <sButton
          v-if="clearable"
          data-qa="textarea-clear_icon"
          :icon="clear_icon || 'cross'"
          icon-size="16px"
          small
          type="text"
          @click="click_clear"/>
      </template>
      <template #label>
        <span
          v-if="label"
          class="mb-1 h8-text black--text"
          data-qa="textarea-label">
          <span
            v-if="required"
            class="h5-headline secondary__red--text">*</span>{{ label }}
        </span>
      </template>
    </v-textarea>
  </div>
</template>
<script>
import { debounce } from 'toolkit/utils/util'

import { textRulesMixin } from 'mixins'

export default {
  name: 'customTextarea',
  mixins: [textRulesMixin],
  props: {
    value: String,
    className: {
      type: String,
      default: () => ''
    },
    area_class_name: String,
    label: String,
    rows: String,
    placeholder: String,
    autofocus: Boolean,
    not_grow: Boolean,
    prefix: String,
    rules: {
      type: Array,
      default: () => []
    },
    errorMessages: [String, Array],
    validateOnBlur: Boolean,
    show_details: Boolean,
    show_details_focused: Boolean,
    clearable: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    rounded: Boolean,
    prepend_inner_icon: String,
    max_length: [String, Number],
    counter: [String, Number],
    counter_value: [String, Number, Function],
    // hint: String,
    ruleFunction: Function,
    clear_icon: String,
    debounce: Boolean,
    required: Boolean,
    error: [Boolean, String],
    error_text: String
  },
  computed: {
    all_rules() {
      if (this.counter || this.max_length) {
        // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
        this.rules.push(this.counterRule)
      }
      return this.rules
    },
    error_sync: {
      get() {
        return this.error
      },
      set(value) {
        this.$emit('update:error', value)
      }
    },
    model_text: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      }
    },
  },
  mounted() {
    this.setRadius()
  },
  methods: {
    setRadius() {
      if ( !this.rounded ) { return }
      let self = this
      setTimeout(() => {
        let ref = self.$refs.bordered_textarea?.$el
        if (!ref) { return }
        let fieldset = ref.querySelector(' fieldset')
        if (fieldset.clientHeight > 45) {
          fieldset.style.borderRadius = '8px'
        } else {
          fieldset.style.borderRadius = '31px'
        }
      }, 50)
    },
    debounceAction: debounce(function () {
      this.$emit('action', this.model_text)
    }, 250),
    click_clear(ev) {
      this.model_text = ''
      this.$emit('click_clear', ev)
    },
  },
  watch: {
    value(text) {
      this.setRadius()
      if (this.validateOnBlur ) {
        this.counterRule(text)
      }
      this.$emit('immediately', text)
      if (this.debounce ) {
        this.debounceAction()
      } else {
        this.$emit('action', text)
      }
    }
  }
}
</script>
<style lang="scss">
.v-input.custom-textarea {
  .v-input__prepend-inner {
    margin-top: 12px;
    max-width: 100%;
  }
  textarea {
    font-size: 14px;
    line-height: 18px;
    min-height: 20px;
    margin-top: 0 !important;
  }
 &.rounded {
   width: 100% !important;
  .v-label {
    transform: translateY(-39px) scale(1);
  }
  fieldset {
    background-color: var(--white-color);
    border: 2px solid var(--v-main__green-base);
    border-radius: 8px;
    legend {
      width: 0 !important;
    }
  }
  &.v-input--is-readonly {
    fieldset {
      border-color: var(--main__green_locked);
      background: var(--secondary__green_locked);
    }
  }
  .v-text-field__slot {
    padding: 10px 0 !important;
  }
  .v-text-field__details {
    margin: 0;
    .v-messages, & {
      height: fit-content;
      min-height: 0;
    }
  }
  &.error--text {
    fieldset {
      border-color: var(--v-secondary__red-base) !important;
    }
    .v-messages {
      color: var(--v-secondary__red-base) !important;
    }
  }
  fieldset {
    border-radius: 31px;
  }
  }
  .v-input__slot {
    &::before, &::after {
      display: none;
    }
  }
}
</style>
